import { DisabledPrompt } from "@bcm-dev/bcms-vite";
import CustomSelect, { CustomSelectItem } from 'components/custom-ui/CustomSelect';
import { ContentHeaderView, FormContainer, FormRowView, WidgetContainer } from 'components/shared';
import { PrimaryButton } from 'components/ui';
import { Profile } from "model";
import "./mobile.css";
import "./styles.css";


/**
* @name ProfilePicker
* @param {Void} 
* @return {OBJECT}
* @description A profile picker shared throughout the module. 
Currently used in the following pages: Bill Pay, Zelle, Cards, and Tax Documents.
*/
export default function ProfilePicker(props) {
  const profileID = props.profileID ?? Profile.getDefaultBrandedProfile().id;
  const selectedProfile = Profile.initByID(profileID);
  const profiles = props.profiles ?? [];
  const title = props.title ?? "Change Current Profile";

 const {ui,onChange,onSelectClick,disableBusiness,mabiZelle} = props;
 let disableProfilePicker = false;
 if((disableBusiness === "true" || disableBusiness === true) && selectedProfile.type === "business") disableProfilePicker = true;
 if(profiles.length === 1 && !mabiZelle) disableProfilePicker = true;

 const items = profiles.reduce((acc, profile) => {
 
  acc.push(
    (disableBusiness === "true" || disableBusiness === true) ?
      profile.type === "business" 
      ? <DisabledPrompt key={ profile.id } value={ profile.id }>
          <CustomSelectItem key={ profile.id } value={ profile.id } dataPoint={ `Current_Profile_Select_Item_${ profile.id }` }>{ profile.name }</CustomSelectItem>
        </DisabledPrompt>
      : <CustomSelectItem key={ profile.id } value={ profile.id } dataPoint={ `Current_Profile_Select_Item_${ profile.id }` }>{ profile.name }</CustomSelectItem> :
      <CustomSelectItem key={ profile.id } value={ profile.id } dataPoint={ `Current_Profile_Select_Item_${ profile.id }` }>{ profile.name }</CustomSelectItem>
  );
  return acc;
}, []);
return  <WidgetContainer className="change-profile-widget">
          <ContentHeaderView text={ title } className="show-on-desktop" />
          <FormContainer className="small-form-width">
            <FormRowView className="profile-select-form-row" text="Current Profile">
              { disableProfilePicker && 
              <DisabledPrompt>
                <CustomSelect active={ ui.currentProfileSelectIsActive } value={ profileID } onChange={ onChange } dataPoint="Current_Profile_Select">{ items }</CustomSelect>
              </DisabledPrompt>
              }
              { !disableProfilePicker && 
                <CustomSelect active={ ui.currentProfileSelectIsActive } value={ profileID } onChange={ onChange } dataPoint="Current_Profile_Select">{ items }</CustomSelect>
              }
            </FormRowView>
            { disableProfilePicker && 
              <DisabledPrompt>
                <PrimaryButton className="change-profile-button" text="Select" dataPoint="Select_Button" onClick={ onSelectClick }/>
              </DisabledPrompt>
            }
            { !disableProfilePicker && 
              <PrimaryButton className="change-profile-button" text="Select" dataPoint="Select_Button" onClick={ onSelectClick }/>
            }
          </FormContainer>
          </WidgetContainer>
}